<template>
  <div class="car-comparison-footer__top-band">
    <div class="container car-comparison-footer__top-band-btn-container">
      <button @click="toggleShowCarsOnMobile" class="car-comparison-footer__btn show-more-btn">
        <small>{{ showCarsOnMobile ? 'Hide' : 'Show' }} cars</small> &nbsp; &nbsp;
        <img
          :src="ChevronIconWhite"
          alt="An icon of a chevron."
          class="car-comparison-footer__btn--icon"
          :class="{
            rotate180: showCarsOnMobile,
          }"
        />
      </button>
      <button @click="showCarComparisonFooter = false" class="car-comparison-footer__btn close-btn">
        <small>{{ comparisonFooter.closeButtonText }}</small> &nbsp; &nbsp;
        <img :src="CloseIconWhite" alt="An icon of a cross." class="car-comparison-footer__btn--icon" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useCarComparisonStore } from '../../foundation/stores/carComparisonStore';
import { useContentStore } from '../../foundation/stores/contentStore';
import ChevronIconWhite from '../../assets/img/chevron-white.svg';
import CloseIconWhite from '../../assets/img/close-white.svg';

const props = defineProps({
  showCarsOnMobile: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['update:showCarsOnMobile']);

const comparisonStore = useCarComparisonStore();
const { showCarComparisonFooter } = storeToRefs(comparisonStore);
const contentStore = useContentStore();
const { comparisonFooter } = storeToRefs(contentStore);

function toggleShowCarsOnMobile() {
  emit('update:showCarsOnMobile', !props.showCarsOnMobile);
}
</script>

<style lang="scss" scoped>
.car-comparison-footer {
  &__top-band {
    height: 2.5rem;
    background: #377ab9;

    &-btn-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    }
  }

  &__btn {
    background: transparent;
    border: none;
    color: #fff;
    font: normal normal normal 0.75rem/1rem Arial;
    position: relative;
    display: flex;
    align-items: center;

    small {
      font-size: 0.75rem;
      line-height: 1rem;
    }

    &--icon {
      width: 12px;
      height: 12px;
      color: #fff;
    }

    &.close-btn {
      right: 0.25rem;

      @media screen and (min-width: #{$breakpoint-md}) {
        right: 0.75rem;
      }
    }

    &.show-more-btn {
      left: 0.25rem;
      visibility: visible;

      @media screen and (min-width: #{$breakpoint-md}) {
        visibility: hidden;
      }
    }

    @media screen and (min-width: #{$breakpoint-xl}) {
      padding: 0;
    }
  }
}
</style>
